import { useEffect, useState } from "react";
import { getWarrantyBilling } from "@/Calls/callWarrantyAuth";
import { Card } from "@/components/ui/card";
import { Loader2, Receipt } from "lucide-react";

export default function WarrantyBillingPage() {
    const [data,    setData]    = useState<{ charges: any[]; total: number; billing_invoice_no: number | null } | null>(null);
    const [loading, setLoading] = useState(true);
    const [month,   setMonth]   = useState("");

    useEffect(() => {
        getWarrantyBilling()
            .then((r) => setData(r.data))
            .catch(() => setData(null))
            .finally(() => setLoading(false));
    }, []);

    const filtered = data?.charges.filter((c) => {
        if (!month) return true;
        const d = new Date(c.charges_created_at);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}` === month;
    }) ?? [];

    const filteredTotal = filtered.reduce((s, c) => s + Number(c.charges_amount), 0);

    if (loading) return (
        <div className="flex justify-center py-20">
            <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
        </div>
    );

    return (
        <div className="max-w-4xl mx-auto space-y-6">
            <div>
                <h1 className="text-2xl font-light uppercase tracking-wide">Billing</h1>
                {data?.billing_invoice_no && (
                    <p className="text-muted-foreground text-sm mt-1">Invoice #{data.billing_invoice_no}</p>
                )}
            </div>

            <div className="flex items-center gap-4">
                <label className="text-sm font-medium">Filter by month</label>
                <input
                    type="month"
                    value={month}
                    onChange={(e) => setMonth(e.target.value)}
                    className="rounded-lg border bg-background px-3 py-1.5 text-sm"
                />
                {month && (
                    <button onClick={() => setMonth("")} className="text-sm text-purple-600 hover:underline">
                        Clear
                    </button>
                )}
            </div>

            <Card className="p-5 flex justify-between items-center">
                <div>
                    <p className="text-sm text-muted-foreground">
                        {month ? `Balance for ${month}` : "Total Balance"}
                    </p>
                    <p className="text-3xl font-bold mt-1">${filteredTotal.toFixed(2)}</p>
                </div>
                <Receipt className="h-8 w-8 text-purple-300" />
            </Card>

            {filtered.length === 0 ? (
                <Card className="p-10 text-center border-dashed">
                    <p className="text-muted-foreground text-sm">No charges for this period</p>
                </Card>
            ) : (
                <Card className="divide-y">
                    <div className="grid grid-cols-4 px-4 py-2 text-xs font-medium text-muted-foreground uppercase tracking-wide">
                        <span className="col-span-2">Description</span>
                        <span>Date</span>
                        <span className="text-right">Amount</span>
                    </div>
                    {filtered.map((c) => (
                        <div key={c.charges_id} className="grid grid-cols-4 px-4 py-3 text-sm items-center">
                            <span className="col-span-2 text-muted-foreground">{c.charges_fee_description}</span>
                            <span className="text-muted-foreground">{new Date(c.charges_created_at).toLocaleDateString()}</span>
                            <span className="text-right font-mono font-medium">${Number(c.charges_amount).toFixed(2)}</span>
                        </div>
                    ))}
                </Card>
            )}
        </div>
    );
}
